var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoSearchResultsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86 79L108.5 101.5C110.5 103.5 110.5 106.5 108.5 108.5C107.5 109.5 106 110 105 110C104 110 102.5 109.5 101.5 108.5L79 86C71.5 91.5 62.5 95 52.5 95C29 95 10 76 10 52.5C10 29 29 10 52.5 10C76 10 95 29 95 52.5C95 62.5 91.5 72 86 79ZM52.5 20C34.5 20 20 34.5 20 52.5C20 70.5 34.5 85 52.5 85C61.5 85 69.5 81.5 75.5 75.5C81.5 69.5 85 61.5 85 52.5C85 34.5 70.5 20 52.5 20Z",
    fill: "#212529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3426_64901",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86 79L108.5 101.5C110.5 103.5 110.5 106.5 108.5 108.5C107.5 109.5 106 110 105 110C104 110 102.5 109.5 101.5 108.5L79 86C71.5 91.5 62.5 95 52.5 95C29 95 10 76 10 52.5C10 29 29 10 52.5 10C76 10 95 29 95 52.5C95 62.5 91.5 72 86 79ZM52.5 20C34.5 20 20 34.5 20 52.5C20 70.5 34.5 85 52.5 85C61.5 85 69.5 81.5 75.5 75.5C81.5 69.5 85 61.5 85 52.5C85 34.5 70.5 20 52.5 20Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3426_64901)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H120V120H0V0Z",
    fill: "#ECF1F7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearchResultsIcon);
export default __webpack_public_path__ + "static/media/NoSearchResultsIcon.e21bc738bbc084e26ffd6c620bedf532.svg";
export { ForwardRef as ReactComponent };